// @flow

import { createSelector } from 'reselect'
import { getRoot } from './rootSelector'
import type { Tag } from '../types'

type Action = {
  type: string,
  payload: Array<Tag>,
}

export function fetchTags() {
  return {
    type: 'FETCH_TAGS',
  }
}

export function addTags(tags: Array<Tag>): Action {
  return {
    type: 'ADD_TAGS',
    payload: tags,
  }
}

export const getTags = createSelector(
  getRoot,
  ({ tags }) => tags || []
)

export default function reducer(
  state: ?Array<Tag> = [],
  { type, payload }: Action
) {
  switch (type) {
    case 'ADD_TAGS':
      return payload
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/tags.js